import {
  createSlice,
  isPending,
  isRejected,
  isFulfilled,
} from '@reduxjs/toolkit';

import { getAppTenant } from './api';
import { RootState } from '../..';
import { IRolePermissions } from '../RolesSlice';

export interface ITenant {
  _id: string;
  name: string;
  key: string;
  domain: string;
  permissions?: IRolePermissions;
  appLogoPath?: string;
  appLogoPath2?: string;
  appLogoPath3?: string;
}

export interface IInitialTenantsState {
  status: 'idle' | 'loading' | 'rejected';
  appTenant?: ITenant;
}

export const TUTOPIYA_TENANT_KEY = 'tutopiya';

const initialState: IInitialTenantsState = {
  status: 'idle',
  appTenant: undefined,
};

export const TenantSlice = createSlice({
  initialState,
  name: 'tenants',
  reducers: {
    resetAppTenant: (state) => {
      state.appTenant = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAppTenant.fulfilled, (state, action) => {
      const result = action.payload;

      state.appTenant = result;
    });

    // Common Matchers
    builder.addMatcher(isPending(getAppTenant), (state) => {
      state.status = 'loading';
    });

    builder.addMatcher(isFulfilled(getAppTenant), (state) => {
      state.status = 'idle';
    });

    builder.addMatcher(isRejected(getAppTenant), (state) => {
      state.status = 'rejected';
    });
  },
});

export const { resetAppTenant } = TenantSlice.actions;

export const getTenantsState = (state: RootState): IInitialTenantsState =>
  state.tenants;

export * from './api';

export default TenantSlice.reducer;
